import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/pages/HowItWorks";

const IMG = "https://images.unsplash.com/photo-1679553621986-698f4d8b8e16?crop=entropy&cs=srgb&fm=jpg&q=85";

const BENEFITS = [
  "Choose the sports you support and set your availability",
  "Receive and respond to match requests from members",
  "Support members through check-ins and scheduled sessions",
  "Build a performance history and strong reputation",
  "Earn rewards and earnings as your members succeed",
];

export default function ForPartners() {
  return (
    <div data-testid="for-partners-page">
      <PageHero eyebrow="For Accountability Partners" title="Motivate. Support. Earn." subtitle="I want to motivate, support and earn rewards." />
      <section className="py-16 md:py-24">
        <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tight">Turn your passion into impact</h2>
            <p className="mt-4 text-zinc-400 leading-relaxed">As a FitLynk Accountability Partner you guide members toward their goals — and get rewarded for the consistency you create. Every partner is reviewed and approved by our team before going live.</p>
            <ul className="mt-8 space-y-4">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="grid place-items-center w-6 h-6 rounded-full bg-[#E53E3E]/15 text-[#E53E3E] mt-0.5 shrink-0"><Check className="w-4 h-4" /></span>
                  <span className="text-zinc-300">{b}</span>
                </li>
              ))}
            </ul>
            <Link to="/get-started">
              <Button size="lg" className="mt-9 bg-[#E53E3E] hover:bg-[#C53030] rounded-full font-semibold h-14 px-8">Become a Partner <ArrowRight className="w-5 h-5 ml-2" /></Button>
            </Link>
          </div>
          <div className="relative rounded-2xl overflow-hidden border border-zinc-800">
            <img src={IMG} alt="Accountability partner coaching" className="w-full h-[420px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
          </div>
        </div>
      </section>
    </div>
  );
}
